// Copyright (c) 2020 Comsearch, Inc., All rights reserved

import { roundAndLeaveTrailingZeroes } from 'helpers/reduxFormFunctions'
import { readonlyPrecisionM } from 'config/constants'

// v is a meters value already.
// but we are going to round it and set it to the specific precision
// returning a string here, we will also leave trailing zeroes if there
// are any.

// if v is null, then this will return an empty string.

const customReadonlyValueMeters = v => roundAndLeaveTrailingZeroes(v, readonlyPrecisionM)

export default customReadonlyValueMeters
